import apiRequestService from 'common/services/api/apiRequestService';
import { Method } from 'common/services/http/types';
import { error as showErrorNotification } from 'common/actions/systemNotifications';

import {
  hideModalContactUs,
  ModalsContactUs,
  setFetchingContactUs,
  showModalContactUsSelector,
  showThankModalContactUs,
} from '../reducers/contactUs';

const sendMessageContactUs = (message: string) => (dispatch, getState) => {
  dispatch(setFetchingContactUs(true));

  return apiRequestService({
    method: `/contactUs`,
    httpMethod: Method.Post,
    body: { message },
  })
    .then(() => {
      dispatch(showThankModalContactUs());

      setTimeout(() => {
        const isCurrentModalThank =
          showModalContactUsSelector(getState()) === ModalsContactUs.ThankModal;

        if (isCurrentModalThank) {
          dispatch(hideModalContactUs());
        }
      }, 2000);
    })
    .catch(({ error }) => {
      dispatch(showErrorNotification(error, 'contactUs'));
    })
    .finally(() => {
      dispatch(setFetchingContactUs(false));
    });
};

export default sendMessageContactUs;
